import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function SupportTickets() {
  const [tickets, setTickets] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/support/admin/tickets").then((res) => {
      setTickets(res.data);
    });
  }, []);

  return (
    <div style={{ padding: 30 }}>
      <h2>🎫 Support Tickets</h2>

      <table border="1" cellPadding="10" width="100%">
        <thead>
          <tr>
            <th>Title</th>
            <th>Priority</th>
            <th>Status</th>
            <th>Replies</th>
          </tr>
        </thead>
        <tbody>
          {tickets.map((t) => (
            <tr key={t.id}>
              <td>
                <button
                  onClick={() => nav(`/admin/support/${t.id}`)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#2563eb",
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                >
                  {t.title}
                </button>
              </td>
              <td>{t.priority}</td>
              <td>{t.status}</td>
              <td>{t.reply_count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
